import { createServerFn } from "@tanstack/react-start";
import { getRequest, setCookie } from "@tanstack/react-start/server";

import { cookieOptions } from "@garimpa/lib/cookieOptions";
import { Cookies } from "@garimpa/lib/cookies";
import { normalizeViewerCurrency } from "@garimpa/lib/viewerPreferences";

export const setCurrencyPreference = createServerFn({ method: "POST" })
  .validator((value: unknown): string => {
    const normalized = normalizeViewerCurrency(value);
    if (!normalized) {
      throw new Error("Invalid currency code");
    }
    return normalized;
  })
  .handler(async ({ data: currency }) => {
    setCookie(
      Cookies.currency.name,
      currency,
      cookieOptions(Cookies.currency, {
        secure: new URL(getRequest().url).protocol === "https:",
      }),
    );
  });
